// dependencies
import React from "react";
import ReactDOM from "react-dom";
import { useHotkeys } from "react-hotkeys-hook";
import { useDispatch } from "react-redux";

// components
import EmployeeSearchComponent from "../../components/EmployeeSearch";

// actions
import { HardPageLoad } from "../../actions/navigation.actions";

// utils
import css from "./EmployeeSearch.module.scss";

// hotkeys ctrl+s to search
const handlers = {
	OPEN_EMPLOYEE_SEARCH: (e) => {
		e.preventDefault();
		focusInput();
	},
};

const focusInput = () => {
	const input = document.getElementById("search-input");
	input.focus();
};

const EmployeeSearch = ({ rootElementId }) => {
	useHotkeys("ctrl+s", handlers.OPEN_EMPLOYEE_SEARCH);

	const dispatch = useDispatch();

	const handleSelectEmployee = (value) => {
		dispatch(HardPageLoad(`/user/${value.value}`));
	};

	const content = (
		<div className={css.searchContainer}>
			<EmployeeSearchComponent onChange={handleSelectEmployee} />
		</div>
	);
	if (!rootElementId) {
		return content;
	}
	const rootElement = document.getElementById(rootElementId);

	return ReactDOM.createPortal(content, rootElement);
};

export default EmployeeSearch;
